import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-088401e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "splash-poster"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "poster-countdown",
  "aria-live": "polite"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "splash-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "特色美食小吃 Top10投票"),
  /*#__PURE__*/_createElementVNode("h1", null, "“贤城优品 · 食在奉贤”")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "home-page"
}
const _hoisted_6 = { class: "hero-section" }
const _hoisted_7 = {
  class: "hotpot-plate",
  "aria-hidden": "true"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<section class=\"notice-card\" data-v-088401e1><p data-v-088401e1><b data-v-088401e1>距投票结束：</b><span data-v-088401e1>投票未开始</span></p><div class=\"notice-row\" data-v-088401e1><b data-v-088401e1>投票须知：</b><div data-v-088401e1><p data-v-088401e1>投票时间</p><p data-v-088401e1>2026年6月19日-2026年9月30日</p><p data-v-088401e1>（入围小吃详情请点击下方图片查看）</p><p data-v-088401e1>投票期间每个微信账号可参与一次，一次3票。</p><p data-v-088401e1>严禁任何作弊行为，系统会进行自动监测，一经发现立即取消投票资格。</p></div></div></section>", 1)
const _hoisted_10 = { class: "stats" }
const _hoisted_11 = { class: "search-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "输入编号或名称搜索", -1))
const _hoisted_13 = { class: "rank-panel" }
const _hoisted_14 = { class: "tabs" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "food-grid" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "food-info" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "投 票", -1))
const _hoisted_22 = {
  key: 1,
  class: "detail-page"
}
const _hoisted_23 = { class: "detail-header" }
const _hoisted_24 = { class: "detail-card detail-info-card" }
const _hoisted_25 = { class: "detail-intro" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "detail-desc" }
const _hoisted_28 = { class: "detail-meta" }
const _hoisted_29 = { class: "detail-meta" }
const _hoisted_30 = { class: "detail-stats" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累积票数", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前排名", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "距上一名", -1))
const _hoisted_34 = { class: "detail-card detail-image-card" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "button" }, "投 票", -1))
const _hoisted_37 = {
  key: 2,
  class: "ranking-page"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rank-ribbon" }, [
  /*#__PURE__*/_createElementVNode("span", null, "实时排名")
], -1))
const _hoisted_39 = { class: "ranking-card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking-tip" }, "— 只显示前100名 —", -1))
const _hoisted_41 = { class: "top-rankers" }
const _hoisted_42 = { class: "top-avatar" }
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = { class: "ranking-list" }
const _hoisted_45 = { class: "rank-no" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { class: "rank-name" }
const _hoisted_48 = {
  key: 3,
  class: "rules-page"
}
const _hoisted_49 = { class: "rules-card" }
const _hoisted_50 = { class: "rules-title" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "活动说明", -1))
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"rules-block\" data-v-088401e1><h3 data-v-088401e1>投票时间</h3><p class=\"rules-date\" data-v-088401e1>2026年6月19日-2026年9月30日</p></div><div class=\"rules-block\" data-v-088401e1><h3 data-v-088401e1>投票须知</h3><p data-v-088401e1>投票时间</p><p data-v-088401e1>2026年6月19日-2026年9月30日</p><p data-v-088401e1>（入围小吃详情请点击下方图片查看）</p><p class=\"rules-gap\" data-v-088401e1>每个微信号每天3票，保留消费记录可在每月美食评选领取礼品。</p><p data-v-088401e1>严禁任何作弊行为，系统会进行自动监测，一经发现立即取消投票资格。</p></div><div class=\"rules-block\" data-v-088401e1><h3 data-v-088401e1>主办单位</h3><strong data-v-088401e1>沪东新村街道党工委、办事处</strong></div>", 3)
const _hoisted_55 = {
  key: 4,
  class: "follow-page"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "qr-logo" }, "消保", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "follow-hint" }, [
  /*#__PURE__*/_createElementVNode("span", null, "长按识别二维码"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "fingerprint-icon",
    "aria-hidden": "true"
  })
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "follow-desc" }, "如无法长按识别，请保存图片后使用“微信扫一扫”识别二维码", -1))
const _hoisted_59 = {
  key: 5,
  class: "bottom-nav"
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "nav-content" }

import { computed, nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import bgPic from '@/assets/pic/bg.jpg'
import itemPic from '@/assets/pic/1.png'
import homePic from '@/assets/pic/homePic.png'

type PageKey = "home" | "detail" | "rank" | "rules" | "follow";

interface FoodItem {
  id: number;
  rank: number;
  code: string;
  name: string;
  votes: number;
  image: string;
  desc: string;
  address: string;
  gap: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const activeTab = ref("人气排名");
const activePage = ref<PageKey>("home");
const isScrolled = ref(false);
const showPoster = ref(true);
const posterCountdown = ref(3);
const tabs = ["潮味排名", "臻品排名", "商户排名"];

const posterImage = bgPic;
const followQrImage =
  "https://api.qrserver.com/v1/create-qr-code/?size=420x420&margin=12&data=https%3A%2F%2Fwww.example.com%2Ffollow";

const stats = [
  { label: "入围商户", value: "32" },
  { label: "累计投票", value: "4972" },
  { label: "访问人数", value: "6540" },
];

const foods: FoodItem[] = [
  {
    id: 1,
    rank: 1,
    code: "01",
    name: "小孟煎饼",
    votes: 756,
    image: itemPic,
    desc: "薄薄的煎饼再加上脆脆的炸片，咬上一口，美味酥脆，加甜面酱，回味无穷。",
    address: "环城东路515号",
    gap: 0,
  },
  {
    id: 2,
    rank: 3,
    code: "02",
    name: "多多米线",
    votes: 674,
    image: itemPic,
    desc: "米线爽滑入味，汤底鲜香浓郁，搭配丰富小料，热气腾腾更显满足。",
    address: "南桥镇人民中路218号",
    gap: 82,
  },
  {
    id: 3,
    rank: 27,
    code: "03",
    name: "牛肉汤面",
    votes: 421,
    image:itemPic,
    desc: "牛肉软烂醇香，面条筋道顺滑，汤头厚实，是街巷里暖胃的一碗。",
    address: "奉浦街道环城西路96号",
    gap: 107,
  },
  {
    id: 4,
    rank: 8,
    code: "04",
    name: "芝麻烧饼",
    votes: 528,
    image:itemPic,
    desc: "外皮焦香酥脆，芝麻香气充足，入口层次分明，越嚼越香。",
    address: "奉城镇川南奉公路128号",
    gap: 15,
  },
];

const selectedFood = ref<FoodItem>(foods[0]);

const rankingItems = [
  { rank: 1, name: "小孟煎饼", votes: 756, image: foods[0].image },
  { rank: 2, name: "多多米线", votes: 674, image: foods[1].image },
  { rank: 3, name: "四团青菜腊肉面", votes: 418, image: foods[2].image },
  { rank: 4, name: "头桥火炉饼", votes: 410, image: foods[3].image },
  {
    rank: 5,
    name: "陈家热气羊肉",
    votes: 327,
    image: "https://images.unsplash.com/photo-1529692236671-f1f6cf9683ba?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 6,
    name: "缙云梅干菜烧饼",
    votes: 283,
    image: "https://images.unsplash.com/photo-1586444248902-2f64eddc13df?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 7,
    name: "阿平生煎",
    votes: 231,
    image: "https://images.unsplash.com/photo-1496116218417-1a781b1c416c?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 8,
    name: "奉城羊肉面",
    votes: 215,
    image: "https://images.unsplash.com/photo-1582878826629-29b7ad1cdc43?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 9,
    name: "木瑶小屋茶果子",
    votes: 212,
    image: "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 10,
    name: "木屋红烧肉",
    votes: 210,
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 11,
    name: "红烩水库大鱼头",
    votes: 185,
    image: "https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?auto=format&fit=crop&w=240&q=80",
  },
  {
    rank: 12,
    name: "海湾农垦包",
    votes: 139,
    image: "https://images.unsplash.com/photo-1563245372-f21724e3856d?auto=format&fit=crop&w=240&q=80",
  },
];

const topRankers = [rankingItems[1], rankingItems[0], rankingItems[2]];
const remainingRankers = rankingItems.slice(3);

const navItems: Array<{ key: PageKey; text: string; icon: string }> = [
  { key: "rank", text: "排行榜", icon: "medal-o" },
  { key: "rules", text: "活动说明", icon: "notes-o" },
  { key: "follow", text: "关注我们", icon: "like-o" },
];

const homeNavText = computed(() => (activePage.value === "home" && isScrolled.value ? "返回顶部" : "首页"));
const homeNavIcon = computed(() => (activePage.value === "home" && isScrolled.value ? "back-top" : "wap-home-o"));
const homeNavKey = computed(() => `${homeNavIcon.value}-${homeNavText.value}`);
const detailFood = computed(() => selectedFood.value);

let scrollFrame = 0;
let posterTimer = 0;
let posterCountdownTimer = 0;
let originalBodyOverflow = "";

const getScrollTop = () => window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

const updateScrollState = () => {
  isScrolled.value = getScrollTop() > 12;
};

const scheduleScrollStateUpdate = () => {
  if (scrollFrame) return;
  scrollFrame = window.requestAnimationFrame(() => {
    scrollFrame = 0;
    updateScrollState();
  });
};

const handleHomeClick = () => {
  if (activePage.value !== "home") {
    switchPage("home");
    return;
  }
  if (getScrollTop() <= 12) return;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const switchPage = async (page: PageKey) => {
  activePage.value = page;
  await nextTick();
  window.scrollTo({ top: 0, behavior: "smooth" });
  updateScrollState();
};

const showDetail = async (food: FoodItem) => {
  selectedFood.value = food;
  activePage.value = "detail";
  await nextTick();
  window.scrollTo({ top: 0, behavior: "smooth" });
  updateScrollState();
};

onMounted(() => {
  originalBodyOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  posterCountdown.value = 3;
  posterCountdownTimer = window.setInterval(() => {
    posterCountdown.value = Math.max(1, posterCountdown.value - 1);
  }, 1000);
  posterTimer = window.setTimeout(() => {
    if (posterCountdownTimer) {
      window.clearInterval(posterCountdownTimer);
      posterCountdownTimer = 0;
    }
    showPoster.value = false;
    document.body.style.overflow = originalBodyOverflow;
  }, 3000);

  updateScrollState();
  window.addEventListener("scroll", scheduleScrollStateUpdate, { passive: true });
  document.addEventListener("scroll", scheduleScrollStateUpdate, { passive: true });
});

onBeforeUnmount(() => {
  if (posterTimer) {
    window.clearTimeout(posterTimer);
  }
  if (posterCountdownTimer) {
    window.clearInterval(posterCountdownTimer);
  }
  document.body.style.overflow = originalBodyOverflow;
  window.removeEventListener("scroll", scheduleScrollStateUpdate);
  document.removeEventListener("scroll", scheduleScrollStateUpdate);
  if (scrollFrame) {
    window.cancelAnimationFrame(scrollFrame);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "poster-fade" }, {
      default: _withCtx(() => [
        (showPoster.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("img", {
                src: _unref(posterImage),
                alt: "活动开屏海报"
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, _toDisplayString(posterCountdown.value) + "s", 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("main", {
      class: _normalizeClass(['vote-page', `vote-page--${activePage.value}`])
    }, [
      (activePage.value === 'home')
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _unref(homePic),
                  alt: "",
                  class: "home-pic"
                }, null, 8, _hoisted_8)
              ])
            ]),
            _hoisted_9,
            _createElementVNode("section", _hoisted_10, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stats, (item) => {
                return _createElementVNode("div", {
                  key: item.label,
                  class: "stats-item"
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.label), 1),
                  _createElementVNode("strong", null, _toDisplayString(item.value), 1)
                ])
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_icon, { name: "search" }),
              _hoisted_12
            ]),
            _createElementVNode("section", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
                  return _createElementVNode("button", {
                    key: tab,
                    class: _normalizeClass({ active: tab === activeTab.value }),
                    type: "button",
                    onClick: ($event: any) => (activeTab.value = tab)
                  }, _toDisplayString(tab), 11, _hoisted_15)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(foods, (food) => {
                  return _createElementVNode("article", {
                    key: food.id,
                    class: "food-card"
                  }, [
                    _createElementVNode("button", {
                      class: "food-img-wrap food-detail-trigger",
                      type: "button",
                      onClick: ($event: any) => (showDetail(food))
                    }, [
                      _createElementVNode("img", {
                        src: food.image,
                        alt: food.name
                      }, null, 8, _hoisted_18),
                      _createElementVNode("span", null, _toDisplayString(food.rank), 1)
                    ], 8, _hoisted_17),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        class: "food-title-btn",
                        type: "button",
                        onClick: ($event: any) => (showDetail(food))
                      }, _toDisplayString(food.name), 9, _hoisted_20),
                      _createElementVNode("strong", null, _toDisplayString(food.votes) + "票", 1),
                      _hoisted_21
                    ])
                  ])
                }), 64))
              ])
            ])
          ]))
        : (activePage.value === 'detail')
          ? (_openBlock(), _createElementBlock("section", _hoisted_22, [
              _createElementVNode("header", _hoisted_23, [
                _createElementVNode("h1", null, _toDisplayString(_unref(detailFood).name), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (switchPage('home')))
                }, [
                  _createVNode(_component_van_icon, { name: "revoke" }),
                  _createTextVNode(" 返回首页 ")
                ])
              ]),
              _createElementVNode("section", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("img", {
                    src: _unref(detailFood).image,
                    alt: _unref(detailFood).name
                  }, null, 8, _hoisted_26),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(detailFood).code) + "号", 1),
                    _createElementVNode("h2", null, _toDisplayString(_unref(detailFood).name), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(detailFood).desc), 1),
                _createElementVNode("p", _hoisted_28, "打卡点：" + _toDisplayString(_unref(detailFood).name), 1),
                _createElementVNode("p", _hoisted_29, "地址：" + _toDisplayString(_unref(detailFood).address), 1),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", null, [
                    _hoisted_31,
                    _createElementVNode("strong", null, _toDisplayString(_unref(detailFood).votes), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("strong", null, _toDisplayString(_unref(detailFood).rank), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_33,
                    _createElementVNode("strong", null, _toDisplayString(_unref(detailFood).gap) + " 票", 1)
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_34, [
                _createElementVNode("img", {
                  src: _unref(detailFood).image,
                  alt: _unref(detailFood).name
                }, null, 8, _hoisted_35),
                _hoisted_36
              ])
            ]))
          : (activePage.value === 'rank')
            ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("section", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(topRankers, (item) => {
                      return _createElementVNode("article", {
                        key: item.rank,
                        class: _normalizeClass(['top-ranker', `top-ranker--${item.rank}`])
                      }, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", null, _toDisplayString(item.rank), 1),
                          _createElementVNode("img", {
                            src: item.image,
                            alt: item.name
                          }, null, 8, _hoisted_43)
                        ]),
                        _createElementVNode("h2", null, _toDisplayString(item.name), 1),
                        _createElementVNode("strong", null, _toDisplayString(item.votes) + "票", 1)
                      ], 2)
                    }), 64))
                  ]),
                  _createElementVNode("ul", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(remainingRankers), (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.rank
                      }, [
                        _createElementVNode("span", _hoisted_45, "NO." + _toDisplayString(item.rank), 1),
                        _createElementVNode("img", {
                          src: item.image,
                          alt: item.name
                        }, null, 8, _hoisted_46),
                        _createElementVNode("span", _hoisted_47, _toDisplayString(item.name), 1),
                        _createElementVNode("strong", null, _toDisplayString(item.votes) + "票", 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (activePage.value === 'rules')
              ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                  _createElementVNode("section", _hoisted_49, [
                    _createElementVNode("header", _hoisted_50, [
                      _createVNode(_component_van_icon, { name: "notes-o" }),
                      _hoisted_51
                    ]),
                    _hoisted_52
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_55, [
                  _createElementVNode("section", { class: "follow-poster" }, [
                    _createElementVNode("div", { class: "qr-frame" }, [
                      _createElementVNode("img", {
                        src: followQrImage,
                        alt: "关注二维码"
                      }),
                      _hoisted_56
                    ]),
                    _hoisted_57
                  ]),
                  _hoisted_58
                ])),
      (activePage.value !== 'detail')
        ? (_openBlock(), _createElementBlock("nav", _hoisted_59, [
            _createElementVNode("a", {
              class: _normalizeClass({ active: activePage.value === 'home' }),
              href: "javascript:void(0)",
              onClick: handleHomeClick
            }, [
              _createVNode(_Transition, {
                name: "nav-swap",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("span", {
                    key: _unref(homeNavKey),
                    class: "nav-content"
                  }, [
                    _createVNode(_component_van_icon, { name: _unref(homeNavIcon) }, null, 8, ["name"]),
                    _createElementVNode("span", null, _toDisplayString(_unref(homeNavText)), 1)
                  ]))
                ]),
                _: 1
              })
            ], 2),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
              return _createElementVNode("a", {
                key: item.key,
                class: _normalizeClass({ active: activePage.value === item.key }),
                href: "javascript:void(0)",
                onClick: ($event: any) => (switchPage(item.key))
              }, [
                _createElementVNode("span", _hoisted_61, [
                  _createVNode(_component_van_icon, {
                    name: item.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("span", null, _toDisplayString(item.text), 1)
                ])
              ], 10, _hoisted_60)
            }), 64))
          ]))
        : _createCommentVNode("", true)
    ], 2), [
      [_vShow, !showPoster.value]
    ])
  ], 64))
}
}

})